/* eslint-disable @typescript-eslint/no-explicit-any */
import { useSuspenseQueryGet } from "../typed-client/hooks/use-suspense-query-get"
import type * as Api from "../@client/api"
import { ComboboxItem, MultiSelect, MultiSelectProps } from "@mantine/core"
import { useDebouncedState } from "@mantine/hooks"

type Unboxed<T> = T extends (infer U)[] ? U : T

export interface RemoteMultiSelectProps<
  ActionName extends keyof Api.GET,
  T = string,
> extends Omit<MultiSelectProps, "data" | "onChange" | "value" | "multiple"> {
  toRequest?: (search: string) => Api.Input[ActionName]
  url: ActionName
  map: (value: Unboxed<Api.Output[ActionName]>) => ComboboxItem
  toValue: (value: string) => T
  fromValue: (value: T) => string
  onChange: (value: T[] | null) => void
  value?: T[] | null
}

export function RemoteMultiSelect<
  ActionName extends keyof Api.GET,
  T = string,
>({
  url,
  map,
  toValue,
  fromValue,
  onChange,
  value,
  toRequest,
  placeholder,
  ...props
}: RemoteMultiSelectProps<ActionName, T>) {
  const [searchValue, setSearchValue] = useDebouncedState("", 2000)
  const request = React.useMemo(
    () => (toRequest ? toRequest(searchValue) : null),
    [searchValue]
  )
  const { data } = useSuspenseQueryGet(url, request as any)

  const options =
    data !== null && data !== undefined && (data as any).map
      ? (data as any[]).map(map)
      : []
  return (
    <MultiSelect
      {...props}
      placeholder={
        value === null || value === undefined || value?.length == 0
          ? placeholder
          : ""
      }
      miw={200}
      rightSectionPointerEvents="none"
      defaultSearchValue={searchValue}
      onSearchChange={(e) => {
        setSearchValue(e)
      }}
      multiple={true}
      value={
        value !== null && value !== undefined && value.map
          ? value.map(fromValue)
          : []
      }
      onChange={(e) => {
        if (e !== null && e !== undefined && e.map) {
          onChange(e.map(toValue))
        }
      }}
      data={options}
    />
  )
}
